import React, { useCallback, useState } from 'react'
import { generatePath, NavLink, useParams } from 'react-router-dom'

import { Nav, Navbar, Pagination, Panel } from 'rsuite'
import TextMaterialsTopMenu from '@components/textMaterials/TextMaterialsTopMenu'
import { AddOutline } from 'react-ionicons'
import { ROUTE_TEXT_MATERIALS_ADD } from '@@partner:config/routes'
import { useFetchAllTextMaterials } from '@@partner:graphql/query/textMaterial/textMaterial/allTextMaterials.gql'
import { CommonSort, NestedFilter } from '@@partner:types:graphql'
import { ORDERS_PER_PAGE_LIMIT } from '@@partner:config'
import { convertToInt } from '@@partner:helpers/util'
import TextMaterialsTable from '@components/textMaterials/textMaterial/grid/TextMaterialsTable'
import TextMaterialsFilter from '@components/textMaterials/textMaterial/grid/TextMaterialsFilter'

export default function TextMaterialManagementPage () {
  const { brandSlug, type = null } = useParams<any>()

  const [ page, setPage ] = useState(1)
  const [ filter, setFilter ] = useState<NestedFilter>({
    fields: [ 'id' ],
    op: 'unwrap'
  })
  const [ sort, setSort ] = useState<CommonSort>({
    fieldName: 'id',
    direction: 0
  })

  const { data, loading, error } = useFetchAllTextMaterials({
    pager: {
      page,
      limit: ORDERS_PER_PAGE_LIMIT
    },
    filter,
    sort
  })

  const handlePageSelect = useCallback((selectedPage: string | number) => {
    setPage(convertToInt(selectedPage))
  }, [])

  const handleSortColumn = useCallback((sortColumn, sortType) => {
    setSort({
      fieldName: sortColumn,
      direction: sortType === 'desc' ? 0 : 1
    })
  }, [])

  const handleFilterChanged = useCallback(
    (updatedFilter: NestedFilter) => {
      setFilter(updatedFilter)
      handlePageSelect(1)
    },
    [ handlePageSelect ]
  )

  const allTextMaterials = data?.allTextMaterials?.edges ?? []
  const pageInfo = data?.allTextMaterials?.pageInfo

  const showPagination = pageInfo?.lastPage !== 1

  return (
    <div className="TextMaterialManagementPage">
      <h1 className="u-heading">Текстовые материалы</h1>
      
      <TextMaterialsTopMenu />
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<AddOutline />}
            as={NavLink}
            to={generatePath(ROUTE_TEXT_MATERIALS_ADD, {
              brandSlug
            })}
          >
             Добавить материал
          </Nav.Item>
        </Nav>
      </Navbar>

      <TextMaterialsFilter onFilterChanged={handleFilterChanged} />

      <Panel shaded>
        <TextMaterialsTable 
          brandSlug={brandSlug}
          textMaterials={allTextMaterials}
          loading={loading}
          onSortColumn={handleSortColumn}
          sortColumn={sort.fieldName}
          sortType={sort.direction === 0 ? 'desc' : 'asc'}
        />

        { showPagination && (
          <Pagination
            size="md"
            last
            first
            next
            prev
            ellipsis
            activePage={page}
            pages={pageInfo?.lastPage}
            total={pageInfo?.lastPage ?? 1}
            maxButtons={10}
            onSelect={handlePageSelect}
          />
        )}
      </Panel>


    </div>
  )
}
